import React, {useState,useRef,useEffect,useContext,useMemo} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { ViewPdfButton, CardPerso,PrintTicketButton,BtnReopenDevis,ColumDataTableReorganize,BtnCopyClipBoard,useLocalStorage} from "@gull";
import axios from 'axios'
import swal from "sweetalert2";
import { useParams } from "react-router-dom";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Moment from 'react-moment';
import DevisA4 from "app/views/Pdf/DevisA4"
import { BlobProvider } from '@react-pdf/renderer';
import { IsAuthContext,PeripheriqueContext } from '../../../app/App';
import { epson_tm_h6000VDevis } from 'app/imprime';
import {scrollXDataTable} from 'app/scrollXDataTable';
import { useCookies} from 'react-cookie';

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columns.length)
    }, [window.screen.width,props.columns.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            remote
            pagination={ paginationFactory(props.paginationOptions) }
            onTableChange={ props.handleTableChange }
            noDataIndication={props.load.allTicket ? <div className="spinner-border spinner-border-sm"></div> : t('tableNoData')}
            defaultSorted={props.defaultSorted}
            rowStyle={ props.rowStyle }
            hover
            condensed
            responsive
        />
    );
};

const SearchHistoriqueDevis = (props) => {
    const t =useTranslate()
    const [allDevis,setAllDevis]=useState([])
    const [load,setLoad]=useState({
        allTicket:false,
    })
    const { posid } = useParams();
    const [perPage,setPerPage] = useState(50)
    const [currentPage,setCurrentPage] = useState(1)
    const [sizeDatas,setSizeDatas]=useState(0)

    const [relance,setRelance]=useState(Date.now())
    const [ticketRef,setTicketRef]=useState(false)
    const [ticketPdf,setTicketPdf]=useState({})
    const [raisonPrint,setRaisonPrint]=useState(false)
    const [totalAchat,setTotalAchat]=useState(0)
    const [totalTgc,setTotalTgc]=useState(false)
    const [loadTicket,setLoadTicket]=useState(false)
    const btnPdf = useRef('')

    const { authParam } = useContext(IsAuthContext)
    const { peripheriqueParam } = useContext(PeripheriqueContext)  

    const [cookies, setCookie] = useCookies(['search_histo_devis_reorganize']);
    const [localStorage, setLocalStorage] = useLocalStorage(['search_histo_devis_reorganize']);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage.search_histo_devis_reorganize && cookies.search_histo_devis_reorganize){
            setLocalStorage('search_histo_devis_reorganize',cookies.search_histo_devis_reorganize);
        }
    }, []);
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 
    const [currentSectionData,setCurrentSectionData]=useState(posid) 

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    let devise = authParam.company.devise;
    let digit = (authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    let thisShop = authParam.sections.find(shop=>shop.id == posid)

    const [urlParam,setUrlParam]=useState({
        section:currentSectionData,
        expire:0,
        client:props.clientId
    })  

    useEffect(function () {
        (async function() {
            if(ticketRef){
                setLoadTicket(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/pos/devis/get_by_reference/"+ticketRef
                ).then((response) => {
                    if(!response.data.valid){
                        let interms='';
                        var keys = Object.keys(response.data.errors);
                        for(var i = 0; i < keys.length; i++){
                            interms+=response.data.errors[keys[i]].join(',')+','
                        }
                        interms=interms.split(',')
                        let messageError='';
                        interms.forEach(interm=>messageError+=t(interm)+'. ')
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                    }
                    else{ 
                        setTicketPdf(response.data.data)
                        
                        var total = 0
                        let totaltgc = {}
                        response.data.data.ticket.ticket_detail.map(item=>{
                            total+=item.prix_remise
                            if(item.tgc!=0){//on exécute pas cette action sur le taux 0
                                if(totaltgc[item.tgc]){
                                    //si le taux de tgc existe deja on ajoute le pris du produit au total existant
                                    totaltgc={...totaltgc,[item.tgc]:totaltgc[item.tgc]+=item.prix_remise}
                                }else{
                                    //Si aucun taux existe on ajoute la taxe 
                                    totaltgc={...totaltgc,[item.tgc]:item.prix_remise}
                                }
                                
                            }
                        })
                        setTotalAchat(total)
                        setTotalTgc(totaltgc)
                        setLoadTicket(false)

                        if(raisonPrint=='print'){
                            epson_tm_h6000VDevis(response.data.data.ticket.section_id,response.data.data,t,devise,peripheriqueParam,false,authParam)
                        }

                        if(raisonPrint=='pdf'){
                            setTimeout(()=>{
                                btnPdf.current.click()
                            },1000)
                        }
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    swal.fire(t('unknowError'), "", "error");
                })
                setLoadTicket(false)

                if(raisonPrint=='pdf'){
                    setTimeout(()=>{
                        btnPdf.current.click()
                    },1000)
                }
            }
        })()
    }, [ticketRef,relance])    
    
    const tgcForTicketPdf = useMemo(()=>{
        let result={}
        Object.entries(totalTgc).forEach(([tgcName,montant])=>{
            //fonction qui calcule le montant de tgc à payer par type de tgc
            let coef = +tgcName / 100 + 1
            let totalAmountTgc = (props.digit==0) ? +montant - (Math.round(+montant / +coef)) : Math.round((+montant - (Math.round((+montant / +coef)*100)/100))*100)/100
            result[tgcName] = totalAmountTgc
        })
        return result
    },[totalTgc,props.digit])
    //on calcule le total de tgc payé sur le ticket
    const tgcTotal = useMemo(()=>
        Object.values(tgcForTicketPdf).reduce((sum,value)=>sum+value,0)
    ,[tgcForTicketPdf])

    // Memoized to keep a stable `document` reference across renders that don't actually change
    // the quote data: BlobProvider regenerates and revokes its blob URL every time the `document`
    // reference changes (@react-pdf/renderer usePDF, effect on [doc]). Without this memo, an
    // unrelated re-render while the blob tab stays open would revoke that URL and break the
    // download icon in the browser's native PDF viewer.
    const devisDocument = useMemo(()=>{
        if(Object.keys(ticketPdf).length==0) return false
        return <DevisA4
            t={t}
            documentType='quotation'
            companyInfos={thisShop}
            authParam={authParam}
            ticketFacture={ticketPdf}
            totalTgc={tgcTotal}
            totalAchat={totalAchat}
            tgcForTicketPdf={tgcForTicketPdf}
            devise={devise}
        />
    },[ticketPdf,thisShop,authParam,tgcTotal,totalAchat,tgcForTicketPdf,devise,t])

    const loadAllTickets = async () =>{
        setLoad({...load,allTicket:true})

        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/devis/get_by_period/"+currentPage+"/"+perPage+"/0/0",urlParam
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                setAllDevis(response.data.datas)
                setSizeDatas(response.data.count)
                setLoad({...load,allTicket:false})
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setLoad({...load,allTicket:false})
    }

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        page:currentPage,
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: sizeDatas
    };

    let dataTable = new Array
    allDevis.length!=0 && allDevis.map((value,ind)=>{
        let obj = {
            ticket: <span className="d-flex"><span>{value.bar}</span>&nbsp;&nbsp;<span style={{width:'100%', textAlign:'end'}}><BtnCopyClipBoard icon='true' textToCopy={value.bar} /></span></span>,
            masque:'',
            client: (value.ticket.client!=null) ? value.ticket.client.name+' '+value.ticket.client.firstname : '',
            originShop:value.ticket.section.name,
            dateExpire: <Moment format="DD/MM/YYYY">{value.validite}</Moment>,
            dateCreation: <Moment format="DD/MM/YYYY">{value.created_at}</Moment>,
            expire:value.expire,
            id: value.id,
            action: 
                <span className="d-flex justify-content-between">
                    <PrintTicketButton setRelance={setRelance} setRaisonPrint={setRaisonPrint} setTicketRef={setTicketRef} ticketRef={value.bar}/>
                    <ViewPdfButton setRelance={setRelance}  setRaisonPrint={setRaisonPrint} setTicketRef={setTicketRef} ticketRef={value.bar} title={t('btnSeeDevisPdf')}/> 
                    <BtnReopenDevis icon='true' posid={posid} ticketId={value.ticket.id}/>
                </span>,
            index: ind + 1,
        }
        dataTable.push(obj)
    })

    let defaultSorted = [
        {
          dataField: "date",
          order: "desc"
        }
    ];

    let columns = [
        {
            dataField: "action",
            text: 'Action',
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
        },
        {
            dataField: "ticket",
            text: t('quotation')+' n°',
            editable: false,
        },
        {
            dataField: "client",
            text: t('customer'),
            editable: false,
        },
        {
            dataField: "originShop",
            text: t('origin_section'),
            editable: false,
        },
        {
            dataField: "dateCreation",
            text: t('createdAt'),
            editable: false,
        },
        {
            dataField: "dateExpire",
            text: t('dateExpire'),
            editable: false,
        },
    ];

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.search_histo_devis_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.search_histo_devis_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("search_histo_devis_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [])

    const handleTableChange = async (type, { page, sizePerPage }) => {
        setPerPage(sizePerPage)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/devis/get_by_period/"+page+"/"+sizePerPage+'/0/0',urlParam
        ).then((response) => {
            setAllDevis(response.data.datas)
            setSizeDatas(response.data.count)
            setCurrentPage(page)
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    const rowStyle = (row, rowIndex) => {
        const style = {};

        if(row.expire){
            style.backgroundColor = '#d9fcd2';//finalisé
        }else{
            style.backgroundColor = '#ffffbb';//en cours
        }

        return style;
    };

    // Quand le client change on charge les commandes
    useEffect(function () {
        if (props.clientId) {
            if (urlParam.client != props.clientId) {
                setUrlParam({...urlParam,client:props.clientId})
                setCurrentPage(1)
            }
        } 
    }, [props.clientId])
    
    // Appelle loadAllTicket quand urlparam est mis à jour
    useEffect(() => {
        if (props.clientId && urlParam) {
            loadAllTickets();
        }
    }, [urlParam]);

    return(<>
        <BlobProvider document={devisDocument}>
            {({ url }) => (
                <a ref={btnPdf} className="d-none" href={url} target="_blank">Print</a>
            )}
        </BlobProvider>
        <CardPerso saClass='position-relative'>
            <div className="mb-2">
                <ColumDataTableReorganize 
                    columnOrganize={columnOrganize}
                    setColumnOrganize={setColumnOrganize}
                    setCookie={setLocalStorage}
                    cookieName='search_histo_devis_reorganize'
                    showColumnOrganize={showColumnOrganize}
                    setShowColumnOrganize={setShowColumnOrganize}
                    btnSwitch={false}//pour affiche ou non le btn swith
                    initSwith={true}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                />
            </div>
            {(loadTicket) ? 
                <div className="loaderPdfHistorique">
                    <span>{(raisonPrint=='pdf') ? t('downloadingPdf') : t('printingInProgress')}</span>&nbsp;
                    <span>
                        <span className="spinner-grow spinner-grow-sm text-dark sizeDotLoad" role="status"></span> 
                        <span className="spinner-grow spinner-grow-sm text-dark sizeDotLoad" role="status"></span> 
                        <span className="spinner-grow spinner-grow-sm text-dark sizeDotLoad" role="status"></span> 
                    </span>
                </div>
            : 
                false
            }
            {(load.allTicket) ? 
                <div className="d-flex justify-content-center"><span className="spinner-border spinner-border-sm"></span></div> 
            :
                columnOrganize.length!=0 && 
                    <small>
                        <ToolkitProvider
                            keyField="index"
                            data={dataTable}
                            columns={ columnOrganize }
                        >
                            {(propst) => (
                                <div className="position-relative">
                                    <CustomDataTable
                                        propst={propst}
                                        paginationOptions={paginationOptions}
                                        handleTableChange={handleTableChange}
                                        load={load}
                                        defaultSorted={defaultSorted}
                                        rowStyle={rowStyle}
                                        columns={columns}
                                    />
                                </div>
                            )}
                        </ToolkitProvider>
                    </small>
            }
        </CardPerso>
        </>
    )
    
}

export default SearchHistoriqueDevis;